import React from "react";
import styles from "./BrandCards.module.css";

const BrandCards = () => {
  const brands = [
    {
      name: "VALMIS",
      image: "/assets/valmis-logo-rectangle.svg",
      description: "Leader in the canned fish category.",
    },
    {
      name: "TUNTSOFF",
      image: "/assets/logos/logo_tsema.png",
      description: "Premium canned fish.",
    },
    {
      name: "ANANASOFF",
      image: "/assets/ananasoff-logo.png",
      description: "Premium canned fruit.",
    },
    {
      name: "OLIVE LAND",
      image: "/assets/olive-land-logo.png",
      description: "Selected Spanish olives.",
    },
  ];

  return (
    <div className={styles.cardsContainer}>
      {brands.map((brand, index) => (
        <div key={index} className={styles.card}>
          <div className={styles.cardInner}>
            {/* Front Side */}
            <div className={styles.cardFront}>
              <img src={brand.image} alt={`${brand.name} Logo`} />
            </div>
            {/* Back Side */}
            <div className={styles.cardBack}>
              <h3>{brand.name}</h3>
              <p>{brand.description}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default BrandCards;
